const getAppliedRoleList = state => state?.appliedRoleData?.appliedRoleList
const getAppliedRoleMetrics = state =>
  state?.appliedRoleData?.appliedRoleMetrics
const getViewRoleData = state => state?.appliedRoleData?.viewRoleData
const getNewRoleCount = state => state?.appliedRoleData?.newRoleCount

const selector = {
  getAppliedRoleList,
  getAppliedRoleMetrics,
  getViewRoleData,
  getNewRoleCount
}

export default selector
